import { render, staticRenderFns } from "./validations.vue?vue&type=template&id=40b2b2d0&v-if=validationName.%24error&"
import script from "./validations.vue?vue&type=script&lang=js&"
export * from "./validations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports